import { AlertView } from '@netfoundry-ui/shared/model';
import { alertTypeLabel } from './alert-type-labels';

/**
 * The question the AI assistant gets when a reader asks it to explain an alert.
 * The id lets the assistant read the alert and its history through the alerting tools. The summary keeps the transcript readable and gives the model context if that read fails.
 */
export function explainAlertPrompt(alert: AlertView): string {
    const parts: { componentName?: string | null; componentId?: string }[] = alert.components?.length ? alert.components : [alert];
    const components = parts
        .map((part) => part.componentName || part.componentId)
        .filter((name) => !!name);
    const subject = components.length > 0 ? ` on ${components.join(', ')}` : '';
    return (
        `Explain alert ${alert.id}: ${alertTypeLabel(alert.alertType)}${subject}, severity ${alert.severity}, status ${alert.status}. ` +
        'What does it mean, what is the likely cause, and what should I check? Be concise.'
    );
}
